import apiClient, { unwrapData } from "./apiClient";

export async function getAppointments(params = {}, options = {}) {
  const response = await apiClient.get("/api/appointments", {
    ...options,
    query: {
      date_from: params.from,
      date_to: params.to,
      from: params.from,
      to: params.to,
      status: params.status,
    },
  });
  const data = unwrapData(response) || {};

  const appointments = Array.isArray(data.appointments)
    ? data.appointments
    : Array.isArray(data.items)
      ? data.items
      : [];

  return {
    appointments: appointments.filter((appointment) => appointment?.date),
  };
}

export async function getPublicSlots(params = {}, options = {}) {
  const response = await apiClient.get("/api/appointments/slots", {
    ...options,
    query: {
      date_from: params.date,
      date_to: params.date,
      date: params.date,
      service_type: params.service_type,
    },
  });
  const data = unwrapData(response) || {};

  return {
    available_slots: Array.isArray(data.available_slots) ? data.available_slots : [],
  };
}

export async function createAppointment(payload = {}, options = {}) {
  const response = await apiClient.post("/api/appointments", {
    ...options,
    body: {
      contact_name: String(payload.contact_name || "").trim(),
      phone_number: String(payload.phone_number || "").trim(),
      requested_date: String(payload.requested_date || "").slice(0, 10),
      requested_time: String(payload.requested_time || "").trim(),
      service_type: String(payload.service_type || "").trim() || undefined,
      summary: String(payload.summary || "").trim() || undefined,
    },
  });

  const data = unwrapData(response) || {};

  return data.appointment_ui || data.appointment || null;
}

export async function updateAppointmentStatus(id, status, options = {}) {
  const response = await apiClient.put(`/api/appointments/${encodeURIComponent(id)}`, {
    ...options,
    body: {
      status,
    },
  });

  return unwrapData(response);
}

export async function rescheduleAppointment(id, payload, options = {}) {
  const response = await apiClient.put(`/api/appointments/${encodeURIComponent(id)}`, {
    ...options,
    body: {
      requested_date: String(payload.new_date || "").slice(0, 10),
      requested_time: payload.new_time_slot || "",
      service_type: payload.service_type || "clinic",
    },
  });

  return unwrapData(response);
}
